import { render, staticRenderFns } from "./SkipButton.vue?vue&type=template&id=884aa67e&scoped=true&"
import script from "./SkipButton.vue?vue&type=script&lang=js&"
export * from "./SkipButton.vue?vue&type=script&lang=js&"
import style0 from "../NextButton/next-button.scss?vue&type=style&index=0&id=884aa67e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884aa67e",
  null
  
)

export default component.exports